module.exports = ".mgr-1{\r\n    margin-left :1%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a2121-ytimeaxis-list/ytimeaxis-list.component.css
// module id = ./src/app/a2121-ytimeaxis-list/ytimeaxis-list.component.css
// module chunks = main